(() => {
  const root = document.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  root.classList.add('vv-js-motion');

  class VvLivingHero extends HTMLElement {
    connectedCallback() {
      if (this.dataset.vvReady) return;
      this.dataset.vvReady = '1';
      if (reduce || this.dataset.motion === 'false') return;
      if (!matchMedia('(hover:hover) and (pointer:fine)').matches || innerWidth < 801) return;

      let frame = 0;
      const reset = () => {
        this.style.setProperty('--vv-bg-x','0px');
        this.style.setProperty('--vv-bg-y','0px');
        this.style.setProperty('--vv-stage-x','0px');
        this.style.setProperty('--vv-stage-y','0px');
        this.style.setProperty('--vv-copy-x','0px');
        this.style.setProperty('--vv-copy-y','0px');
      };
      this.addEventListener('pointermove',(event) => {
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const r=this.getBoundingClientRect();
          const x=Math.max(-1,Math.min(1,((event.clientX-r.left)/r.width-.5)*2));
          const y=Math.max(-1,Math.min(1,((event.clientY-r.top)/r.height-.5)*2));
          this.style.setProperty('--vv-bg-x',`${(-x*1.6).toFixed(2)}px`);
          this.style.setProperty('--vv-bg-y',`${(-y*1.1).toFixed(2)}px`);
          this.style.setProperty('--vv-stage-x',`${(x*1.4).toFixed(2)}px`);
          this.style.setProperty('--vv-stage-y',`${(y*.9).toFixed(2)}px`);
          this.style.setProperty('--vv-copy-x',`${(-x*.65).toFixed(2)}px`);
          this.style.setProperty('--vv-copy-y',`${(-y*.45).toFixed(2)}px`);
        });
      },{passive:true});
      this.addEventListener('pointerleave',reset,{passive:true});
    }
  }

  if (!customElements.get('vv-living-hero')) customElements.define('vv-living-hero',VvLivingHero);

  const revealTargets=[...document.querySelectorAll('.vv-origin__copy,.vv-origin__card,.vv-featured__head,.vv-card,.vv-story__content,.vv-journal-card,.vv-page-head,.vv-rte')];
  if (reduce || !('IntersectionObserver' in window)) revealTargets.forEach(el=>el.classList.add('is-visible'));
  else {
    revealTargets.forEach(el=>el.classList.add('vv-revealable'));
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{if(!entry.isIntersecting)return;entry.target.classList.add('is-visible');observer.unobserve(entry.target)}),{threshold:.08,rootMargin:'0px 0px -3% 0px'});
    revealTargets.forEach(el=>observer.observe(el));
  }

  document.addEventListener('click',(event)=>{
    const button=event.target.closest('[data-vv-menu-toggle]');
    if(button){const menu=document.querySelector('[data-vv-mobile-menu]');if(!menu)return;const open=menu.classList.toggle('is-open');button.setAttribute('aria-expanded',String(open));return}
    const galleryButton=event.target.closest('[data-vv-gallery-target]');
    if(galleryButton){const rootGallery=galleryButton.closest('[data-vv-product-gallery]');if(!rootGallery)return;const target=galleryButton.dataset.vvGalleryTarget;rootGallery.querySelectorAll('[data-vv-gallery-image]').forEach(image=>image.classList.toggle('is-active',image.dataset.vvGalleryImage===target));rootGallery.querySelectorAll('[data-vv-gallery-target]').forEach(thumb=>thumb.classList.toggle('is-active',thumb===galleryButton))}
  });

  document.addEventListener('change',(event)=>{
    const select=event.target.closest('[data-vv-variant-select]');if(!select)return;const option=select.options[select.selectedIndex];const productRoot=select.closest('[data-vv-product-root]');if(!productRoot||!option)return;const idInput=productRoot.querySelector('input[name="id"]');const price=productRoot.querySelector('[data-vv-product-price]');if(idInput)idInput.value=option.value;if(price&&option.dataset.price)price.textContent=option.dataset.price
  });
})();
